<template>
  <div
    v-if="statisticsCard"
    class="bi-statistic-card"
    :class="small ? 'small' : ''"
  >
    <div class="bi-statistic-card--content">
      <div class="bi-statistic-card--header">
        <span class="bi-statistic-card--icon">
          <i class="fas" :class="icon"></i>
        </span>
      </div>
      <div class="bi-statistic-card--body">
        <h4 class="bi-statistic-card--number">{{ internalData[0] }}</h4>
        <h4 class="bi-statistic-card--title">
          {{ title }}
          <!-- <div
            v-if="internalPercentage !== null"
            class="bi-statistic-card--percentage"
            :class="internalPercentageType"
          >
            <i class="fas fa-arrow-up"></i> {{ internalPercentage }} %
          </div> -->
        </h4>
      </div>
    </div>
    <div
      v-if="internalPercentage !== null && internalData[1]"
      class="bi-statistic-card--percentage"
      :class="internalPercentageType"
    >
      <span><i class="fas fa-arrow-up"></i> {{ internalPercentage }} %</span>
      <span class="bi-statistic-card--percentage-count"
        >({{ internalData[1] }})</span
      >
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
const stringToEnum = function(string) {
  let result = "";
  for (let i = 0; i < string.length; i++) {
    const char = string.charAt(i);
    const upper = char.toUpperCase();
    if (char === upper) {
      result += "_";
    }
    result += upper;
  }
  return result;
};
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    id: {
      type: String,
      default: null
    },
    data: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    percentage: {
      type: [String, Number],
      default: null
    },
    percentageType: {
      type: String,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    limitDays: {
      type: Object,
      default: null
    },
    compareStart: {
      type: Object,
      default: null
    },
    compareStop: {
      type: Object,
      default: null
    },
    limitStop: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    adCampaignCompareStats: {}
  }),
  apollo: {
    statisticsCard: {
      query: gql`
        query StatisticsCard($filter: StatisticsCardFilter!) {
          statisticsCard(filter: $filter) {
            data
            dataType
            statType
            hasComparison
            compareData
            comparePercentage
          }
        }
      `,
      variables() {
        return {
          filter: {
            statType: this.type,
            adCampaigns: this.id ? [this.id] : undefined,
            metric: stringToEnum(this.data),
            dateFilter:
              this.limitDays && this.limitStop
                ? {
                    fromTime: this.limitDays,
                    toTime: this.limitStop
                  }
                : undefined,
            comparisonDateFilter:
              this.compareStop && this.compareStart
                ? {
                    fromTime: this.compareStart,
                    toTime: this.compareStop
                  }
                : undefined
          }
        };
      }
    }
  },
  computed: {
    internalPercentageType() {
      return (
        this.percentageType ||
        (this.statisticsCard.comparePercentage >= 0 ? "up" : "down")
      );
    },
    internalPercentage() {
      return this.statisticsCard.comparePercentage !== null
        ? this.statisticsCard.comparePercentage.toFixed(2)
        : null;
    },
    internalData() {
      if (this.data == "cost" || this.data == "costPerApplication") {
        const formatter = new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: "EUR"
        });
        return [
          formatter.format(this.statisticsCard.data),
          formatter.format(this.statisticsCard.compareData)
        ];
      } else if (this.data == "ctr") {
        const formatter = new Intl.NumberFormat(undefined, {
          style: "percent",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        return [
          formatter.format(this.statisticsCard.data),
          formatter.format(this.statisticsCard.compareData)
        ];
      }
      if (this.statisticsCard.dataType == "FLOAT") {
        const formatter = new Intl.NumberFormat(undefined, {
          maximumFractionDigits: 2
        });
        return [
          formatter.format(this.statisticsCard.data),
          formatter.format(this.statisticsCard.compareData)
        ];
      }
      if (this.statisticsCard.compareData) {
        return [
          this.statisticsCard.data.toLocaleString(),
          this.statisticsCard.compareData.toLocaleString()
        ];
      } else {
        return [this.statisticsCard.data.toLocaleString()];
      }
    }
  }
};
</script>
